import { Vue, BitrixVue } from 'ui.vue';
import './style.css'
Vue.component('vue-product-quantity-progress-bar', {
    data: function () {
        return {
            count: 0,
            possibility: null
        }
    },
    computed: {
        index(state) {
            return state.count++;
        },
        localize(state) {
            return BX.Vue.getFilteredPhrases("");
        },
        cartProduct(state) {
            return state.$store.getters['basket/findItem'](state.$props.productId);
        },
        cartProductPossibility(state) {
            return parseFloat(state.cartProduct?.CAN_BUY_IN_PERCENT);
        },
        catalogProduct(state) {
            return state.$store.getters['catalog/findItem'](state.$props.productId);
        },
        catalogProductPossibility(state) {
            return parseFloat(state.catalogProduct?.CAN_BUY_IN_PERCENT);
        },
        productName(state) {
            return state.catalogProduct?.NAME;
        },
        productBasketProgressTitle: (state) => {
            return state.localize.PRODUCT_BASKET_PROGRESS
                ?.replace('#POSIBILITY#', state.productProgressPosibility)
                ?.replace('#PRODUCT#', state.productName);
        },
        productQuantity(state) {
            state.possibility = 0;
            return parseFloat(state.catalogProduct.QUANTITY||0);
        },
        productProgressPosibility(state) {
            if (state.$props.progressPosibility
                && state.possibility != state.$props.progressPosibility
            ) {
                state.possibility = state.$props.progressPosibility;
            } else if (parseInt(state.catalogProduct?.QUANTITY) != parseInt(state.cartProduct?.QUANTITY)
                && state.catalogProductPossibility >= 0
                && state.possibility != state.catalogProductPossibility
            ) {
                state.possibility = state.catalogProductPossibility;
            } else if (state.cartProductPossibility >= 0
                && state.possibility != state.cartProductPossibility
            ) {
                state.possibility = state.cartProductPossibility;
            }
            return state.possibility;
        },
    },
    mounted() { },
    methods: {},
    props: {
        'progressPosibility': Number,
        'productId': Number
    },
    template: `
        <div :id="'PROGRESS_'+productId"
            v-if="productQuantity && (cartProduct || cartProduct.CAN_BUY_IN_PERCENT)"
            class="vue-product-quantity-progress-bar-init progress"
            :title="productBasketProgressTitle"
        >
            <div :id="'PROGRESS_BAR_SUCCESS_'+productId"
                class="progress-bar progress-bar-success"
                role="progressbar"
                :aria-valuenow="productProgressPosibility"
                aria-valuemin="0"
                aria-valuemax="100"
                :style="{width: productProgressPosibility+'%'}"
            >
            </div>
            <div :id="'PROGRESS_BAR_WRONG_'+productId"
                class="progress-bar progress-bar-wrong"
                role="progressbar"
                :aria-valuenow="(100-productProgressPosibility)"
                aria-valuemin="0"
                aria-valuemax="100"
                :style="{width: (100-productProgressPosibility)+'%'}"
            >
            </div>
        </div>`
});
